import Tabs from './tabs.vue';
import Pane from './pane.vue';

Tabs.Pane = Pane;
export default Tabs;


// WEBPACK FOOTER //
// ./src/components/tabs/index.js